import * as React from 'react';
export const aplazoSvg = React.forwardRef(function aplazoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.038 1.099c-.862.205-1.687.772-2.651 1.79C3.944 4.403 2.764 6.436 1.602 9.39 1.087 10.69 0 14.083 0 14.377c0 .146.178.234.862.43.88.254 1.012.254 1.012.02 0-.265 1.03-3.452 1.508-4.655.6-1.525 1.433-3.236 2.07-4.243.675-1.066 1.724-2.2 2.408-2.581 1.17-.646 2.042-.323 2.744 1.017.328.635.638 1.652.525 1.76-.019.019-.412.156-.88.293-1.574.479-3.083 1.35-3.72 2.15-.346.44-.693 1.262-.768 1.81-.084.586.094 1.574.384 2.18.338.675.975 1.3 1.705 1.662.572.284.703.313 1.565.313.834 0 1.002-.03 1.499-.274 1.414-.684 1.939-1.73 2.201-4.321a56 56 0 0 1 .131-1.3c.019-.147-.018-.216-.13-.216-.272 0-1.63.303-1.715.381-.038.04-.15.646-.253 1.36-.094.704-.234 1.407-.319 1.554-.58 1.183-2.351 1.134-2.932-.068-.909-1.868 1.162-3.256 5.827-3.901.824-.118 1.677-.235 1.902-.264.384-.05.403-.069.356-.313a12.154 12.154 0 0 1-.103-.978c-.075-.821.075-.763-1.537-.557-.637.088-1.17.136-1.19.117-.018-.02-.14-.42-.271-.9-.3-1.056-.693-1.867-1.237-2.493C10.69 1.255 9.33.776 8.038 1.1Z',
    }),
  );
});
aplazoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var aplazo = {
  category: 'paymentmethod',
  colorable: true,
  name: 'aplazo',
  svg: aplazoSvg,
};
